// extracted by mini-css-extract-plugin
export var backButton = "_10-1";
export var content = "_10-d";
export var continueButton = "_10-7";
export var continueHint = "_10-8";
export var continueRow = "_10-6";
export var leftInner = "_10-0";
export var shell = "_10-e";
export var sidebarContent = "_10-5";
export var skipButton = "_10-c";
export var spacer = "_10-2";
export var spin = "_10-a";
export var spinner = "_10-9";
export var spinnerOverlay = "_10-b";
export var subtitle = "_10-4";
export var title = "_10-3";